import { render, staticRenderFns } from "./ChatCorrespondenceUser.vue?vue&type=template&id=77759d96&scoped=true&"
import script from "./ChatCorrespondenceUser.vue?vue&type=script&lang=js&"
export * from "./ChatCorrespondenceUser.vue?vue&type=script&lang=js&"
import style0 from "./ChatCorrespondenceUser.vue?vue&type=style&index=0&id=77759d96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77759d96",
  null
  
)

export default component.exports